import carrierFormFieldsSaga from '~/sagas/carrier-form-fields/carrier-form-fields.saga';

export default carrierFormFieldsSaga;
